import { FC } from 'react';

import clsx from 'clsx';

import { BreadcrumbsProps } from './types';

import styles from './styles.module.scss';

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ crumbs }) => {
  if (!crumbs.length) return null;

  return (
    <div className={styles.breadcrumbs}>
      {crumbs.map(({ name }, index) => {
        return (
          <div
            key={name}
            className={clsx(styles.breadcrumbsItem, index === crumbs.length - 1 && styles.breadcrumbsActive)}
          >
            {name}
          </div>
        );
      })}
    </div>
  );
};
